import React, {useState, useEffect, useContext} from 'react';
import {graphql} from 'react-apollo';

import URLSearchParams from '@ungap/url-search-params';

import translate from '../../../utils/translations';
import VrbexContext from '../../context/VrbexContext';

import {AcceptTravelerStayInvite} from './AcceptTravelerStayInviteMutations';
import LoadingErrorDisplay from '../../LoadingErrorDisplay/LoadingErrorDisplay';
import {categories} from './utils/constants';
import {MUTATION_STATES as STATES} from './constants';

import Conversation from '../Conversation';

import './ConversationWrapper.less';

// TODO: Write the test case for ConversationWrapper(https://jira.expedia.biz/browse/SE-4574)

const ConversationWrapper = ({
    acceptTravelerStayInvite,
    activeTab,
    backUrl,
    conversationId,
    isGuestModalOpen,
    search,
    systemData,
    tabChange,
    translations,
    path,
}) => {
    const {isVrbex, isVrbexNative} = useContext(VrbexContext);
    const [isInviteMutationCalled, setIsInviteMutationCalled] = useState(false);
    const params = new URLSearchParams(search);
    const isAcceptInviteCase = params.get('task') === 'acceptInvite';
    const [returnState, setReturnState] = useState(
        isAcceptInviteCase && !isInviteMutationCalled
            ? STATES.LOADING_CASE
            : STATES.NOT_ACCEPT_INVITE_CASE
    );

    useEffect(() => {
        if (isAcceptInviteCase && !isInviteMutationCalled) {
            setIsInviteMutationCalled(true);
            const reservationId = params.get('reservationId');
            acceptTravelerStayInvite({
                variables: {
                    request: {
                        reservationUUID: reservationId,
                    },
                },
            })
                .then((res) => {
                    if (
                        res.data.acceptTravelerStayInvite.result === 'SUCCESS'
                    ) {
                        setReturnState(STATES.VALID_CASE);
                    } else {
                        setReturnState(STATES.INVALID_CASE);
                    }
                })
                .catch(() => setReturnState(STATES.INVALID_CASE));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let conversationJSX = null;
    const commonProps = {
        activeTab,
        backUrl,
        categories,
        conversationId,
        isGuestModalOpen,
        search,
        systemData,
        tabChange,
        translations,
        path,
    };
    const conversationContent = (
        <Conversation
            isHybridInbox={isVrbex || isVrbexNative}
            {...commonProps}
        />
    );

    switch (returnState) {
        case STATES.VALID_CASE: {
            conversationJSX = conversationContent;
            break;
        }
        case STATES.INVALID_CASE: {
            conversationJSX = (
                <div className="ConversationError">
                    <LoadingErrorDisplay
                        ctaLabel={translate(
                            translations,
                            'trav-dash/trav-home',
                            'nav',
                            'th.header.logout'
                        )}
                        ctaLink={'/auth/ui/logout'}
                        message={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.unknown.traveler.error.message'
                        )}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.unknown.traveler.error.title'
                        )}
                    />
                </div>
            );
            break;
        }
        case STATES.NOT_ACCEPT_INVITE_CASE: {
            conversationJSX = conversationContent;
            break;
        }
        default: {
            conversationJSX = null;
        }
    }

    return conversationJSX;
};

export default graphql(AcceptTravelerStayInvite, {
    name: 'acceptTravelerStayInvite',
})(ConversationWrapper);
